import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import { useTranslation } from "../../../localization/useTranslation.ts";
import React from "react";
import { FrameworkCategoryViewModel } from "../FrameworkCategories.types.ts";
import { useFrameworkCategoryDialog } from "./FrameworkCategoryDialog.hooks.ts";

export interface FrameworkCategoryDialogProps {
    onDialogClose: () => void;
    frameworkId: string;
    model: FrameworkCategoryViewModel | undefined;
}

function FrameworkCategoryDialog(props: FrameworkCategoryDialogProps) {
    const { translateString } = useTranslation();
    const { validation, updater, saveModel, save, isSaving, isEdit } = useFrameworkCategoryDialog(props);

    validation.check(saveModel);
    return (
        <DotLegalDialog
            buttonOkText={isEdit ? translateString("save") : translateString("create")}
            size="sm"
            header={`${isEdit ? translateString("edit") : translateString("create")} ${translateString("category")}`}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={save}
            inProgress={isSaving}
            disableBackdropOnCloseIfValueChange={saveModel}
        >
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <Box sx={{ width: "100%" }}>
                    <DotLegalTextField
                        errorText={validation.getErrorsForDisplay("name")}
                        label={translateString("name")}
                        value={saveModel.name}
                        debounce={false}
                        onChange={updater.onNameChange}
                    />

                    <DotLegalTextField
                        label={translateString("description")}
                        onChange={updater.onDescriptionChange}
                        multiline
                        rows={3}
                        value={saveModel.description ?? null}
                        debounce={false}
                    />

                    <DotLegalTextField label={translateString("id")} onChange={updater.onCustomIdChange} value={saveModel.customId ?? null} debounce={false} />
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default FrameworkCategoryDialog;
